import { Trans } from '@lingui/macro'

import * as React from 'react'

import { PaymentMethodSelect, useAvailablePaymentMethodsCtx } from '~shared/segments/PaymentMethods'
import { InputGroup } from '~ui/components/formElements/accessories/InputGroup'
import { InputLabel } from '~ui/components/formElements/accessories/InputLabel'
import { Box } from '~ui/components/layout/Box'

import {
  useSelectedPaymentMethodCtx,
  useSetPaymentMethodCtx,
} from '../contexts/OrderLockedPaymentMethodProvider'

const MAX_BUTTON_WIDTH = 10 // rem

type TProps = NoChildren

/**
 * Payment method select (multi switch) with the translated label.
 * Uses `availablePaymentMethods` & `selectedMethod` of the `OrderLockedScreen`.
 */
export const OrderLockedPaymentMethod: React.FC<TProps> = () => {
  const selectedMethod = useSelectedPaymentMethodCtx()
  const setSelectedMethod = useSetPaymentMethodCtx()

  const { availableMethods } = useAvailablePaymentMethodsCtx()

  const paymentMethodsCount = availableMethods?.length

  return (
    <InputGroup
      padding={{ top: `medium`, left: `none`, right: `none`, bottom: `none` }}
      width={`100%`}
      maxWidth={`min(100%, ${(paymentMethodsCount ?? 2) * MAX_BUTTON_WIDTH}rem)`}
      rowGap={`small`}
    >
      <InputLabel padding={`none`}>
        <Trans>Payment method</Trans>
      </InputLabel>

      <Box justifySelf={`stretch`}>
        <PaymentMethodSelect
          onSelect={setSelectedMethod}
          selectedMethod={selectedMethod}
          availableMethods={availableMethods}
        />
      </Box>
    </InputGroup>
  )
}
